import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                accentLightBlue: '#C9CDDD',
                accentDarkBlue: '#24305E',
                accentMediumBlue: '#24305E',
                warning: '#FFAA2C',
                error: '#F83E70',
                info: '#3CD1C2',

                googleColor: '#B9B9B9',
                facebookColor: '#3A559F'
            }
        }
    }
});